import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { OctopusMascot } from "@/components/Mascot";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("art3d_token", data.token);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err, "Falha no login"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-soft-gradient flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="w-full max-w-sm bg-white rounded-3xl shadow-card p-8">
        <div className="flex flex-col items-center mb-6">
          <OctopusMascot size={64} wave />
          <h1 className="text-2xl font-black text-slate-900 mt-3">Painel <span className="text-gradient">Art3D</span></h1>
          <p className="text-sm text-slate-500 mt-1">Entre para editar sua loja</p>
        </div>
        <form onSubmit={submit} className="flex flex-col gap-4">
          <div>
            <label className="text-xs font-bold text-slate-600 mb-1.5 block">E-mail</label>
            <input
              type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-email-input"
              className="w-full px-4 py-3 rounded-xl border border-slate-200 text-sm outline-none focus:border-pink-300 focus:ring-2 focus:ring-pink-100"
              placeholder="admin@art3d.com"
            />
          </div>
          <div>
            <label className="text-xs font-bold text-slate-600 mb-1.5 block">Senha</label>
            <input
              type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-password-input"
              className="w-full px-4 py-3 rounded-xl border border-slate-200 text-sm outline-none focus:border-pink-300 focus:ring-2 focus:ring-pink-100"
              placeholder="••••••••"
            />
          </div>
          {error && <p className="text-sm text-red-500 font-semibold" data-testid="admin-login-error">{error}</p>}
          <button
            type="submit" disabled={loading}
            data-testid="admin-login-submit"
            className="bg-brand-gradient text-white font-bold py-3.5 rounded-full shadow-soft transition-all active:scale-95 disabled:opacity-60"
          >
            {loading ? "Entrando..." : "Entrar"}
          </button>
          <a href="/" className="text-center text-xs text-slate-400 hover:text-pink-500 font-semibold">← Voltar para a loja</a>
        </form>
      </div>
    </div>
  );
}
